export default "__VITE_ASSET__Bvzt3$lt__"